import React from "react";
import BetControls from "./BetControls";
import Common from "./Common";
import { Value } from "./core/Value";
import DynamicInput from './DynamicInput';
import { Comm } from "./core/comm/Comm";
import { Controller } from "./core/Controller";
import DynamicValue from './DynamicValue';
import { EVENTS } from "./core/EVENTS";

class BetControl extends React.Component<BetControl.Props, BetControl.State>
{

    gameState: string;

    value_bet: Value;
    value_cashout: Value;
    value_btn_cashout: Value;

    constructor(props: BetControl.Props)
    {
        super(props);

        const min_bet = Value.getNumber(Value.ID.MIN_BET).value
        const max_bet = Value.getNumber(Value.ID.MAX_BET).value
        const min_cashout = Value.getNumber(Value.ID.MIN_CASHOUT).value
        const max_cashout = Value.getNumber(Value.ID.MAX_CASHOUT).value

        this.value_bet = Value.getNumber(Value.ID.BET + "_" + props.index, min_bet, {
            decimals: 2,
            min: min_bet,
            max: max_bet
        });

        this.value_cashout = Value.getNumber(Value.ID.CASHOUT + "_" + props.index, 1.10, {
            decimals: 2,
            min: min_cashout,
            max: max_cashout
        });

        this.value_btn_cashout = Value.getNumber("cashout_btn_" + props.index, 1.00, {
            decimals: 2
        });

        this.state = {
            locked: props.static ? false : ["start", "init"].includes(Controller.state),
            coin_denominations: Controller.coinDenominations,
            bet_step: Controller.betLimit?.step ?? .1
        };
    }


    componentDidMount()
    {
        Comm.on(Comm.RESPONSE.INITIALIZE, this.onInitialize, this);

        if (!this.props.static)
        {
            Comm.on(Comm.RESPONSE.GAME_STATE_STARTING, this.onStarting, this);
            Comm.on(Comm.RESPONSE.GAME_STATE_START, this.onStart, this);
            Comm.on(Comm.RESPONSE.GAME_STATE_IN_PROGRESS, this.onProgress, this);
            Comm.on(Comm.RESPONSE.GAME_STATE_CRASH, this.onCrash, this);
    
            Comm.on(Comm.RESPONSE.BET, this.onBetResponse, this);
            Comm.on(Comm.RESPONSE.CANCEL_BET, this.onCancelBetResponse, this);
            Comm.on(Comm.RESPONSE.CASHOUT, this.onCashoutResponse, this);
        }
    }
    

    componentWillUnmount()
    {
        Comm.off(Comm.RESPONSE.INITIALIZE, this.onInitialize, this);

        Comm.off(Comm.RESPONSE.GAME_STATE_STARTING, this.onStarting, this);
        Comm.off(Comm.RESPONSE.GAME_STATE_START, this.onStart, this);
        Comm.off(Comm.RESPONSE.GAME_STATE_IN_PROGRESS, this.onProgress, this);
        Comm.off(Comm.RESPONSE.GAME_STATE_CRASH, this.onCrash, this);

        Comm.off(Comm.RESPONSE.BET, this.onBetResponse, this);
        Comm.off(Comm.RESPONSE.CANCEL_BET, this.onCancelBetResponse, this);
        Comm.off(Comm.RESPONSE.CASHOUT, this.onCashoutResponse, this);
    }


    onInitialize(data: Comm.ResponseTypes.Init, init: boolean, serviceRestarted: boolean)
    {
        const bet_step = Number(data.game.limits.bet.step || .1);

        const min_bet = Value.getNumber(Value.ID.MIN_BET).value
        const max_bet = Value.getNumber(Value.ID.MAX_BET).value
        const min_cashout = Value.getNumber(Value.ID.MIN_CASHOUT).value
        const max_cashout = Value.getNumber(Value.ID.MAX_CASHOUT).value

        this.value_bet.setOptions({
            min: min_bet,
            max: max_bet,
        });
        this.value_cashout.setOptions({
            min: min_cashout,
            max: max_cashout
        });

        this.setState({
            locked: this.props.static ? false : ["start", "init"].includes(Controller.state),
            bet_step: bet_step,
            coin_denominations: data.game.limits.coin_denominations
        });
    }


    onStarting(data: Comm.ResponseTypes.GameStateStarting)
    {
        this.gameState = data.state;

        if (this.props.view.betState == "waiting")
        {
            this.placeBet();
        }
        
        this.props.onViewUpdate(this.props.view);
    }


    onStart(data: Comm.ResponseTypes.GameState)
    {
        this.gameState = data.state;

        this.setState({
            locked: true
        });
    }


    onProgress(data: Comm.ResponseTypes.GameState)
    {
        if (this.gameState != data.state)
        {
            this.gameState = data.state;
            
            // TODO: check with cancel pending...
            if (this.props.view.id != null)
            {
                this.props.view.betStatePending = false;
                this.props.view.betState = "cashout";

                this.props.onViewUpdate(this.props.view);
            }
        }

        if (this.props.view.id != null)
        {
            this.value_btn_cashout.value = Math.floor(this.value_bet.value * data.plane.distance * 100) * .01;
        }
        
        if (this.state.locked)
        {
            this.setState({
                locked: false
            });
        }
    }


    onCrash(data: Comm.ResponseTypes.GameState)
    {
        this.gameState = data.state;

        // TODO: check with cashout pending...
        if (this.props.view.betStatePending)
        {
            return;
        }

        if (this.props.view.id != null)
        {
            this.props.view.betState = "bet";
            this.props.view.betStatePending = false;
            this.props.view.id = null;
        }

        if (this.props.view.autoBet)
        {
            this.clickBetButton();
        }

        this.props.onViewUpdate(this.props.view);
    }


    clickBet(bet: number)
    {
        if (this.props.static) { return; }

        if (this.props.view.lastBetClicked == bet)
        {
            this.value_bet.value = Number(this.value_bet.value) + bet;
        }
        else
        {
            this.value_bet.value = bet;
            
            this.props.view.lastBetClicked = bet;
            this.props.onViewUpdate(this.props.view);
        }
    }


    clickMenu(menuIdx: number)
    {
        if (this.props.static) { return; }

        this.props.view.menuIdx = menuIdx;
        this.props.onViewUpdate(this.props.view);
    }


    onBetInputChanged()
    {
        if (this.props.static) { return; }

        this.props.view.lastBetClicked = null;
        this.props.onViewUpdate(this.props.view);
    }


    increaseBet()
    {
        if (this.props.static) { return; }

        this.props.view.lastBetClicked = null;
        this.value_bet.setValue(Number(this.value_bet.value) + this.state.bet_step, true, true);
        this.props.onViewUpdate(this.props.view);
    }


    decreaseBet()
    {
        if (this.props.static) { return; }

        this.props.view.lastBetClicked = null;
        this.value_bet.setValue(Number(this.value_bet.value) - this.state.bet_step, true, true);
        this.props.onViewUpdate(this.props.view);
    }


    toggleAutoBet()
    {
        if (this.props.static) { return; }

        this.props.view.autoBet = !this.props.view.autoBet;

        if (this.props.view.autoBet && this.props.view.betState == "bet")
        {
            this.clickBetButton();
        }
        else if (!this.props.view.autoBet && (this.props.view.betState == "cancel" || this.props.view.betState == "waiting"))
        {
            this.clickCancelButton();
        }

        this.props.onViewUpdate(this.props.view);
    }


    toggleAutoCashout()
    {
        if (this.props.static) { return; }

        this.props.view.autoCashout = !this.props.view.autoCashout;

        this.props.onViewUpdate(this.props.view);
    }


    clickBetButton()
    {
        if (this.props.view.betStatePending || this.props.static)
        {
            return;
        }

        EVENTS.emit(EVENTS.GAME.BUTTON_CLICK);

        if (Controller.state == "starting")
        {
            this.placeBet();
        }
        else
        {
            this.props.view.betStatePending = false;
            this.props.view.betState = "waiting";
        }

        this.props.onViewUpdate(this.props.view);
    }


    clickCancelButton()
    {
        if (this.props.view.betStatePending || this.props.static)
        {
            return;
        }

        EVENTS.emit(EVENTS.GAME.BUTTON_CLICK);

        this.props.view.autoBet = false;

        if (this.props.view.betState == "waiting")
        {
            this.props.view.betState = "bet";
        }
        else
        {
            this.props.view.betStatePending = true;

            this.props.view.uuid = Controller.cancel(this.props.view.id);
        }

        this.props.onViewUpdate(this.props.view);
    }


    clickCashoutButton()
    {
        if (this.props.view.betStatePending || this.props.static)
        {
            return;
        }

        EVENTS.emit(EVENTS.GAME.BUTTON_CLICK);

        this.cashout();

        this.props.onViewUpdate(this.props.view);
    }


    placeBet()
    {
        if (this.props.static) { return; }

        this.props.view.betStatePending = true;
        this.props.view.betState = "bet";
        this.props.view.uuid = Controller.placeBet(
            this.value_bet.value,
            this.props.view.autoCashout ? this.value_cashout.value : null
        );

        this.props.onViewUpdate(this.props.view);
    }


    onBetResponse(data: Comm.ResponseTypes.Bet)
    {
        if (data.uuid !== this.props.view.uuid) { return; }
        
        if (!data.error)
        {
            this.props.view.id = data.bet_id;
            this.props.view.betState = "cancel";
        }
        else
        {
            this.props.view.autoBet = false;
        }

        this.props.view.betStatePending = false;

        this.props.onViewUpdate(this.props.view);
    }


    onCancelBetResponse(data: Comm.ResponseTypes.CancelBet)
    {
        if (!((this.props.view.uuid && this.props.view.uuid == data.uuid) || this.props.view.id == data.bet_id)) { return; }

        if (!data.error)
        {
            this.props.view.id = null;
            this.props.view.betState = "bet";
        }
        else
        {
            this.props.view.autoBet = false;
        }

        this.props.view.betStatePending = false;

        this.props.onViewUpdate(this.props.view);
    }


    cashout()
    {
        if (this.props.static) { return; }

        this.props.view.betStatePending = true;

        this.props.view.uuid = Controller.cashout(this.props.view.id);
    }


    onCashoutResponse(data: Comm.ResponseTypes.Cashout)
    {
        if (!((this.props.view.uuid && this.props.view.uuid == data.uuid) || data.bet_id == this.props.view.id))
        {
            return;
        }

        this.props.view.betState = "bet";
        this.props.view.id = null;

        this.props.view.betStatePending = false;

        // TODO: check what happens with auto bet on timed out...
        if (!data.error)
        {
            if (this.props.view.autoBet)
            {
                this.clickBetButton();
            }
        }

        this.props.onViewUpdate(this.props.view);
    }


    renderBetButton()
    {
        const lang = window.lang.game["bet-controls"]["bet-control"];
        const lShared = window.lang.shared;

        if (this.props.view.betState == "bet")
        {
            return (
                <div
                    className="button down bet font_upper"
                    onClick={this.clickBetButton.bind(this)}
                    key="bet"
                >
                    <div>{lShared.bet}</div>
                    <div className="money">
                        <div>
                            <DynamicValue
                                id={"bet_" + this.props.index}
                            />
                        </div>
                        <div className="currency">
                            &nbsp;{currency}
                        </div>
                    </div>
                </div>
            );
        }
        else if (this.props.view.betState == "waiting")
        {
            return (
                <div 
                    className="betButtonHolder"
                    key="waiting"
                >
                    <div className="betButtonInfo">
                        {lShared["waiting_for_next_round"]}
                    </div>
                    <div
                        className="button down bet font_upper"
                        onClick={this.clickCancelButton.bind(this)}
                    >
                        {lShared["cancel"]}
                    </div>
                </div>
            );
        }
        else if (this.props.view.betState == "cancel")
        {
            return (
                <div
                    className="button down bet font_upper"
                    onClick={this.clickCancelButton.bind(this)}
                    key="cancel"
                >
                    {lShared["cancel"]}

                </div>
            );
        }
        else if (this.props.view.betState == "cashout")
        {
            return (
                <div
                    className="button down bet font_upper"
                    onClick={this.clickCashoutButton.bind(this)}
                    key="cashout"
                >
                    <div>
                        {lShared["cash_out"]}
                    </div>
                    <div className="money">
                        <div>
                            <DynamicValue
                                id={"cashout_btn_" + this.props.index}
                            />
                        </div>
                        <div className="currency">
                            &nbsp;{currency}
                        </div>
                    </div>
                </div>
            );
        }
    }


    renderViewsButton()
    {
        if (this.props.onAdd)
        {
            return (
                <div
                    className={"button down add enabled"}
                    onClick={this.props.onAdd}
                >

                </div>
            )
        }
        else if (this.props.onRemove)
        {
            const enabled = (this.props.view.betState == "bet" || this.props.view.betState == "waiting") && !this.props.view.betStatePending;

            return (
                <div
                    className={"button down remove " + (enabled ? "enabled" : "disabled")}
                    onClick={this.props.onRemove}
                >

                </div>
            );
        }
    }


    render()
    {
        const lang = window.lang.game["bet-controls"]["bet-control"];
        const lShared = window.lang.shared;

        const disabled_all = this.props.view.betStatePending || this.state.locked;
        const disabled_switcher = this.props.view.autoCashout;
        const disabled_cashout_input = !this.props.view.autoCashout;
        const disabled_bet_input = this.props.view.betState !== "bet";
        const disabled_cashout = this.props.view.betState !== "bet";
        const color = this.props.view.betState !== "bet" ? (this.props.view.betState == "cashout" ? "cashout" : "cancel") : null;
    
        return (
            <div
                className={[
                    "control",
                    "bgtex",
                    disabled_all && "disabled",
                    color
                ].filter(Boolean).join(" ")}
            >
    
                <div className="head">
    
                    <div
                        className={[
                            "switcher",
                            disabled_switcher && "disabled"
                        ].filter(Boolean).join(" ")}
                    >
                        <div
                            className="switch highlighter"
                            style={{
                                transform: "translate(" + this.props.view.menuIdx * 100 + "px, 0)"
                            }}
                        ></div>
                        <div
                            className={"switch " + (this.props.view.menuIdx == 0 ? "selected" : "")}
                            onClick={this.clickMenu.bind(this, 0)}
                        >
                            {lShared["bet"]}
                        </div>
                        <div
                            className={"switch " + (this.props.view.menuIdx == 1 ? "selected" : "")}
                            onClick={this.clickMenu.bind(this, 1)}
                        >
                            {lShared["auto"]}
                        </div>
                    </div>
    
                </div>
    
                <div className="content">
    
                    <div className="betArea">
    
                        <div
                            className={[
                                "inputArea",
                                disabled_bet_input && "disabled"
                            ].filter(Boolean).join(" ")}
                        >
                            <div className="input">
                                <div
                                    className="button down icon_circle_minus"
                                    onClick={this.decreaseBet.bind(this)}
                                ></div>
                                <DynamicInput
                                    id={Value.ID.BET + "_" + this.props.index}
                                    className="input_text"
                                    onChange={this.onBetInputChanged.bind(this)}
                                    placeholder={Value.getNumber(Value.ID.MIN_BET).value.toString()}
                                    forcedValue={this.props.static ? "" : null}
                                />
                                <div
                                    className="button down icon_circle_plus"
                                    onClick={this.increaseBet.bind(this)}
                                ></div>
                            </div>
    
                            <div className="btnGroup">
                                <div className="row">
                                    {this.state.coin_denominations[0] && (
                                        <div
                                            className="button down"
                                            onClick={this.clickBet.bind(this, this.state.coin_denominations[0])}
                                        >
                                            {Number(this.state.coin_denominations[0])}
                                        </div>
                                    )}
                                    {this.state.coin_denominations[1] && (
                                        <div
                                            className="button down"
                                            onClick={this.clickBet.bind(this, this.state.coin_denominations[1])}
                                        >
                                            {Number(this.state.coin_denominations[1])}
                                        </div>
                                    )}
                                </div>
                                <div className="row">
                                    {this.state.coin_denominations[2] && (
                                        <div
                                            className="button down"
                                            onClick={this.clickBet.bind(this, this.state.coin_denominations[2])}
                                        >
                                            {Number(this.state.coin_denominations[2])}
                                        </div>
                                    )}
    
                                    {this.state.coin_denominations[3] && (
                                        <div
                                            className="button down"
                                            onClick={this.clickBet.bind(this, this.state.coin_denominations[3])}
                                        >
                                            {Number(this.state.coin_denominations[3])}
                                        </div>
                                    )}
    
                                </div>
                            </div>
                        </div>
    
                        {this.renderBetButton()}
    
                    </div>
    
                </div>
    
                {this.props.view.menuIdx == 1 && (
                    <div className="separator"></div>
                )}
    
                <div
                    className={"autoArea " + (this.props.view.menuIdx != 1 ? "hidden" : "")}
                >
                    <div className="auto_bet">
                        <div className="label font_low">
                            {lang["auto bet"]}
                        </div>
                        <label className="radio_switch">
                            <input
                                type="checkbox"
                                checked={this.props.view.autoBet}
                                onChange={this.toggleAutoBet.bind(this)}
                            />
                            <span className="slider"></span>
                        </label>
                    </div>
    
                    <div className="auto_cashout">
                        <div className="label font_low">
                            {lang["auto cashout"]}
                        </div>
                        <label className={[
                            "radio_switch",
                            disabled_cashout && "disabled"
                        ].filter(Boolean).join(" ")}>
                            <input
                                type="checkbox"
                                checked={this.props.view.autoCashout}
                                onChange={this.toggleAutoCashout.bind(this)}
                            />
                            <span className="slider"></span>
                        </label>
                        <div
                            className={[
                                "input",
                                (disabled_cashout_input || disabled_cashout) && "disabled"
                            ].filter(Boolean).join(" ")}
                        >
                            <DynamicInput
                                className="input_text"
                                id={Value.ID.CASHOUT + "_" + this.props.index}
                            />
                            <div className="icon_x">×</div>
                        </div>
                    </div>
                </div>
    
                {this.renderViewsButton()}
    
            </div>
        );
    }

}

namespace BetControl
{

    export interface Props
    {
        view: BetControls.BetView;
        index: number;
        onViewUpdate: (view: BetControls.BetView) => void;
        onAdd?: () => void;
        onRemove?: () => void;

        static?: boolean;
    }

    export interface State
    {
        locked: boolean;
        coin_denominations: Array<number>;
        bet_step: number;
    }

}

export default BetControl;